export default __webpack_public_path__ + "static/media/falcon_join_hover_2.cc713229.svg";